/*
  fm-market-switcher: drives Freakmount's curated country/currency switcher (snippets/fm-market-switcher.liquid).

  Deliberately independent of Dawn's localization-form.js: market entries carry data-value and switch
  the Shopify market by setting the localization form's country_code and submitting; the Japan entry
  carries data-external and simply navigates to the distributor site (Dawn's handler would have
  preventDefault'd that click and submitted the form instead).
*/
if (!customElements.get('fm-market-switcher')) {
  customElements.define(
    'fm-market-switcher',
    class FmMarketSwitcher extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button.localization-form__select');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        this.input = this.querySelector('input[name="country_code"]');
        this.form = this.querySelector('form');
        this.overlay = this.querySelector('.country-selector__overlay');
        this.headerWrapper = document.querySelector('.header-wrapper');

        if (!this.button || !this.panel) return;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      get isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      toggle() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
        if (this.hasAttribute('data-prevent-hide') && this.headerWrapper) {
          this.headerWrapper.preventHide = true;
        }
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
        if (this.hasAttribute('data-prevent-hide') && this.headerWrapper) {
          this.headerWrapper.preventHide = false;
        }
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.close();
      }

      onKeyUp(event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.isOpen) {
          this.close();
          this.button.focus();
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const item = event.currentTarget;
        const external = item.getAttribute('data-external');
        if (external) {
          window.location.href = external;
          return;
        }
        if (this.input) this.input.value = item.getAttribute('data-value');
        if (this.form) this.form.submit();
      }
    }
  );
}
